import { render, staticRenderFns } from "./ContratoIndex.vue?vue&type=template&id=9c39a2a8"
import script from "./ContratoIndex.vue?vue&type=script&lang=js"
export * from "./ContratoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports